import useMount from '@src/utils/hooks/use-mount';
import { observable } from 'mobx';
import BaseStore from '@src/utils/store/base-store';
import BaseSwiperStore from '@src/components/swiper/base-swiper/store';
import { useEffect } from 'react';
import { useLayerData } from '@src/utils/hooks/use-layer-data';
import $$tracker from '@src/tracker';
class ProjectStore extends BaseStore {
  constructor(options = {}) {
    super();
    Object.assign(this, options);
  }

  @observable mainStore;
  @observable loading = false;

  @observable itemList = [];

  @observable
  arr = [
    {
      id: 0
    },
    {
      id: 1
    },
    {
      id: 2
    },
    {
      id: 3
    },
    {
      id: 4
    },
    {
      id: 5
    },
    {
      id: 6
    },
    {
      id: 6
    },
    {
      id: 6
    },
    {
      id: 6
    }
  ];

  @observable indexList = [];

  @observable indexsActive = 0;

  projectSwiper = new BaseSwiperStore({
    swiperOptions: {
      loop: false,
      allowTouchMove: true,
      slidesPerGroup: 4,
      slidesPerView: 4,
      // spaceBetween: '2.6%',
      autoplay: false
    }
  });

  onPrev = () => {
    this.projectSwiper?.goPrev();
  };

  goSlide = count => {
    const index = count * 4;
    this.projectSwiper?.onChange(index);
  };

  onNext = () => {
    this.projectSwiper?.goNext();
  };

  /**
   * 点击查看详情
   */
  onDetailClick(item) {
    $$tracker.clickProject(item.item_title);
    sessionStorage.setItem('from', JSON.stringify(['首页', '招募项目']));

    
    const currentUrl = new URL(window.location.href);
    
    currentUrl.hash = '';
   
    let newUrlString = "";
    if (currentUrl.toString().includes('index.html')) {
      newUrlString = currentUrl.toString().replace('index.html', 'article.html');
      newUrlString += `#/?contentId=${item.contentIdKey}`;
    }else {
      newUrlString = currentUrl + `index/article.html#/?contentId=${item.contentIdKey}`
    }
    // let newUrlString = currentUrl.toString().replace('index.html', 'article.html');
    // newUrlString += `#/?contentId=${item.contentIdKey}`;
    window.location.href = newUrlString;

    // let fullPath = window.location.origin + window.location.pathname;
    // let urlWithoutFileName = fullPath.replace(/\/[^\/]+\.html$/, '/');
    // // 如果路径末尾没有斜杠，则添加斜杠（可选）
    // if (!urlWithoutFileName.endsWith('/')) {
    //   urlWithoutFileName += '/';
    // }
    // let nextUrl = urlWithoutFileName + 'article.html#/?contentId=${item.contentIdKey}';
    // window.location.href = nextUrl;
  }

  /**
   * 点击查看全部
   */
  onDetailClick1() {
    $$tracker.clickProjectMore();
    sessionStorage.setItem('from', JSON.stringify(['首页', '招募列表']));


    const currentUrl = new URL(window.location.href);
    currentUrl.hash = '';
   
    let newUrlString = "";
    if (currentUrl.toString().includes('index.html')) {
      newUrlString = currentUrl.toString().replace('index.html', 'list.html');
    }else {
      newUrlString  = currentUrl + `index/list.html`
    }
    // let newUrlString = currentUrl.toString().replace('index.html', 'list.html');
    // let newUrlString  = currentUrl + `/index/list.html`
    window.location.href = newUrlString;
    // let fullPath = window.location.origin + window.location.pathname;
    // let urlWithoutFileName = fullPath.replace(/\/[^\/]+\.html$/, '/');
    // // 如果路径末尾没有斜杠，则添加斜杠（可选）
    // if (!urlWithoutFileName.endsWith('/')) {
    //   urlWithoutFileName += '/';
    // }
    // let nextUrl = urlWithoutFileName + 'list.html';
    // window.location.href = nextUrl;
  }

  //前往购买

  use() {
    super.use();
    const layerData = useLayerData('part3');
    // const pageData = useFunLinkPageData();

    useEffect(
      () => {
        if (layerData) {
          // console.log(layerData, 'layerData');
          this.itemList = layerData.typeList?.filter(item => item.isShow === '1').map(item => {
            let isRecruit = false;

            const endDate = item.time;
            const targetDate = new Date(endDate * 1000);
            const currentDate = new Date();
            // console.log(targetDate, 'targetDate', currentDate);

            // 是否在招募中
            if (targetDate > currentDate) {
              isRecruit = true;
            }

            return {
              ...item,
              isRecruit
            };
          });
          if (this.itemList.length > 4) {
            this.loading = true;
          }
          this.itemList.sort((a, b) => a.creatTime - b.creatTime);
          console.log(this.itemList, 'this.itemList', this.loading);
        }
      },
      [layerData]
    );

    useEffect(
      () => {
        // console.log(this.itemList.length, 'this.itemList');

        if (this.itemList.length && this.itemList.length > 4) {
          this.indexList = Array(Math.ceil(this.itemList.length / 4)).fill(1);
        }
      },
      [this.itemList]
    );

    useEffect(
      () => {
        const isEnd = (this.projectSwiper.activeIndex + 4) % 4;
        const currentIndex = Math.floor((this.projectSwiper.activeIndex + 4) / 4);

        if (isEnd) {
          this.indexsActive = currentIndex + 1;
        } else {
          this.indexsActive = currentIndex;
        }
      },
      [this.projectSwiper.activeIndex]
    );

    useMount(() => {});
  }
}

export default ProjectStore;
